// extracted by mini-css-extract-plugin
module.exports = {"container":"i_E5","heading":"i_E6","body":"i_E7","label":"i_E8","link":"i_E9"};